import type { ComponentProps } from "react";
import { useSearchParams } from "react-router";
import { AdminDataNotice } from "@/components/admin/data-notice";
import { ProspectionView } from "@/components/admin/prospection-view";
import { useAdminView } from "@shared/client/admin-view";
import { usePageTitle } from "@shared/client/view";

type ProspectionData = Pick<ComponentProps<typeof ProspectionView>, "board" | "stats" | "machine">;

export default function AdminProspectionPage() {
  usePageTitle("Prospection — Administration Hune");
  const [params] = useSearchParams();
  // Changer d'étape garde l'écran affiché pendant le chargement de la suivante.
  const { data, error } = useAdminView<ProspectionData>("/api/views/admin/prospection", { keepPrevious: true });
  if (error) return <AdminDataNotice error={error} />;
  if (!data) return null;
  return <ProspectionView {...data} search={params.get("search") ?? ""} />;
}
